import { useTranslations } from '@fenetech/translations';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Autocomplete, Checkbox, Chip, TextField } from '@mui/material';
import { OrderTypesEnum } from "helpers/enums";
import useIsMobile from "helpers/hooks/useIsMobile";
import { SplitPascalCaseIntoWords } from "helpers/objects";
import * as React from 'react';

interface IProps {
    orderTypesDataSource: OrderTypesEnum[];
    selectedOrderTypes: OrderTypesEnum[];
    setSelectedOrderTypes: React.Dispatch<React.SetStateAction<OrderTypesEnum[]>>
}

const OrderTypeFilter: React.FC<IProps> = ({orderTypesDataSource, selectedOrderTypes, setSelectedOrderTypes}: IProps) => {

  const tm = useTranslations();
  const isMobile = useIsMobile();
  
  const onSelectedOrderTypesChange = React.useCallback((_, data: OrderTypesEnum[]) => {
      setSelectedOrderTypes(data);
  }, [setSelectedOrderTypes]);

  const getOptionLabel = React.useCallback((option: OrderTypesEnum) => {
    return tm.Get(SplitPascalCaseIntoWords(OrderTypesEnum[option]));
  }, [tm]);

  return <>
      <Autocomplete
          autoComplete
          autoHighlight
          selectOnFocus
          disableClearable
          blurOnSelect={false}
          handleHomeEndKeys
          options={orderTypesDataSource}
          limitTags={isMobile ? 0 : undefined}
          multiple
          fullWidth
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={getOptionLabel}
          renderInput={(params) => (
              <TextField
                  variant="outlined"
                  {...params}
                  label={tm.Get("Order Type")}
                  InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                          <>
                              {params.InputProps.endAdornment}
                          </>
                      ),
                  }}
              />
          )}
          renderOption={(props, option, { selected }) => (
              <li {...props}>
                  <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                  />
                  {tm.Get(SplitPascalCaseIntoWords(OrderTypesEnum[option]))}
              </li>
          )}
          renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });
                  return (
                      <Chip
                          label={tm.Get(SplitPascalCaseIntoWords(OrderTypesEnum[option]))}
                          {...tagProps}
                          deleteIcon={<CancelIcon />}
                          key={option}
                      />
                  );
              })
          }
          onChange={onSelectedOrderTypesChange}
          value={selectedOrderTypes}
      />

  </>

};

export default OrderTypeFilter;